<template>
  <div v-bind:class="cardClass">
      <!-- box -->

    <p
      class="title is-6 has-text-centered"
      v-on:click="$emit('click')"
    >
      <b-tooltip :label="screenTypeInfo">
        <i v-bind:class="'fas ' + screenTypeIcon"></i>
      </b-tooltip> &nbsp;
      {{ screen.name }}
    </p>
    <div class="has-text-centered">
      <span class="icon" v-on:click="$emit('click')">

        <b-tooltip :label="screen.subcategory[0].name">
          <i v-bind:class="'fas fa-3x ' + screen.subcategory[0].esgissue.icon"></i>
        </b-tooltip>
      </span>
      <div class="field toggle-widget topMargin">
        <ScreenSlider
          v-if="(mode === 'screening' || mode === 'selecting') && !screen.is_binary && screen.manuallySet"
          v-bind:screen="screen"
          v-on:change="updatePercentile"
        />
        <ScreenSliderHML
          v-if="mode === 'hml' && !screen.is_binary"
          v-bind:screen="screen"
          v-on:change="updatePercentile"
        />
        <ScreenSwitch
          v-if="mode === 'selecting' || screen.is_binary || (mode === 'screening' && !screen.manuallySet)"
          v-bind:screen="screen"
          v-on:change="updatePercentile"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';

  import ScreenSwitch from '@frontend/builder/js/components/ScreenSwitch.vue';
  import ScreenSlider from '@frontend/builder/js/components/ScreenSlider.vue';
  import ScreenSliderHML from '@frontend/builder/js/components/ScreenSliderHML.vue';

  import eventBus from '@frontend/shared/EventBus.js';

  export default {
    data() {
      return {
      }
    },
    props: {
      screen: Object,
      applicable: {
        default: true,
        type: Boolean,
      },
      active: {
        default: false,
        type: Boolean,
      },
      mode: {
        type: String,
        default: 'screening',
        validator: function (value) { // Are we applying screens to a universe or just choosing them?
          return ['screening', 'selecting', 'hml',].indexOf(value) !== -1
        }
      },
    },
    components: {
      ScreenSlider, ScreenSwitch, ScreenSliderHML,
    },
    computed: {
      cardClass: function() {
        let mode = this.screen.userPercentile !== 0 ? '' : 'is-light';
        let color = 'is-' + this.screen.subcategory[0].esgissue.slug;
        let isApplied = this.screen.userPercentile > 0 ? 'applied' : '';
        let isActive = this.active ? 'active' : '';
        let isApplicable = this.applicable ? '' : 'not-applicable';
        return `notification esgcard ${mode} ${color} ${isApplicable} ${isActive} ${isApplied}`;
      },
      screenTypeIcon() {
        if (this.screen.is_binary && this.screen.is_inclusionary) {
          return 'fa-plus-circle';
        }
        if (this.screen.is_binary && !this.screen.is_inclusionary) {
          return 'fa-minus-circle';
        }
        return 'fa-sliders-h';
      },
      screenTypeInfo() {
        if (this.screen.is_binary && this.screen.is_inclusionary) {
          return 'Positive Binary Screen';
        }
        if (this.screen.is_binary && !this.screen.is_inclusionary) {
          return 'Negative Binary Screen';
        }
        return 'Threshold Screen';

      },
    },
    methods: {
      formatHmlTicks: function(val) {
        const vals = {
          0: 'Not applied',
          1: 'Applied',
          2: 'Most important',
        }
        return vals[val];
      },
      defaultSetPercentile: function() {
        if (this.screen.is_binary) {
          return 100;
        }
        if (this.mode === 'hml') {
          return 1;
        }
        return 10;
      },
      updatePercentile: function(newValue) {
        this.screen.userPercentile = newValue;
        this.emitChangeEvent();
      },
      emitChangeEvent: function(evt) {
        eventBus.$emit('screens-changed', this.screen);
      },
    }
  }
</script>

<style lang="scss">
.esgcard {
  .inclusion-switch.switch .check::before {
    // background-color: green;
  }
  .field.toggle-widget .switch-widget.b-tooltip {
    .tooltip-content {
      top: 50px;
    }
  }
}
</style>


